export const STUDIO_ACTIONS = {
  FREE_TEXT_EDIT: 'FREE_TEXT_EDIT',
  ADD_LOGO: 'ADD_LOGO',
  ADD_TEXT: 'ADD_TEXT',
  ADD_VISUAL_ELEMENTS_FROM_TEXT: 'ADD_VISUAL_ELEMENTS_FROM_TEXT',
  ADD_VISUAL_ELEMENTS_FROM_IMAGE: 'ADD_VISUAL_ELEMENTS_FROM_IMAGE',
  ADD_ROOM_FOR_TEXT: 'ADD_ROOM_FOR_TEXT',
  ADD_REALISM: 'ADD_REALISM',
  CHANGE_SETTING: 'CHANGE_SETTING',
  CHANGE_ELEMENT: 'CHANGE_ELEMENT',
  CHANGE_BRAND_LOOK: 'CHANGE_BRAND_LOOK',
  CHANGE_STYLE: 'CHANGE_STYLE',
  CHANGE_CUTOUT_ELEMENT: 'CHANGE_CUTOUT_ELEMENT',
  CREATE_FORMATS: 'CREATE_FORMATS',
  CREATE_ANGLES: 'CREATE_ANGLES',
  CREATE_VARIANTS: 'CREATE_VARIANTS',
  CONCEPT_RECREATE: 'CONCEPT_RECREATE',
  MERGE_IMAGES: 'MERGE_IMAGES',
  CREATE_VIDEO: 'CREATE_VIDEO',
};

export const STUDIO_API_OPERATION_TYPES = {
  ASPECT_RATIO: 'ASPECT_RATIO',
  CREATE: 'CREATE',
  PROMPT_WITH_REFERENCES: 'PROMPT_WITH_REFERENCES',
  CHANGE: 'CHANGE',
  ADD: 'ADD',
  RECREATE: 'RECREATE',
  CUTOUT: 'CUTOUT',
  ANIMATE: 'ANIMATE',
};

export const STUDIO_API_CREATE_SUBTYPES = {
  VARIANTS: 'VARIANTS',
  ANGLES: 'ANGLES',
  ROOM_FOR_TEXT: 'ROOM_FOR_TEXT',
  REALISM: 'REALISM',
};

export const STUDIO_API_CHANGE_SUBTYPES = {
  SETTINGS: 'SETTINGS',
  STYLE: 'STYLE',
  ELEMENT: 'ELEMENT',
};

export const STUDIO_API_ADD_SUBTYPES = {
  LOGO: 'LOGO',
  TEXT: 'TEXT',
  VISUAL_ELEMENTS_FROM_TEXT: 'VISUAL_ELEMENTS_FROM_TEXT',
  VISUAL_ELEMENTS_FROM_IMAGE: 'VISUAL_ELEMENTS_FROM_IMAGE',
};

export const STUDIO_API_PROMPT_WITH_REFERENCES_SUBTYPES = {
  FREE_TEXT: 'FREE_TEXT',
  BRAND_LOOK: 'BRAND_LOOK',
  MERGE_IMAGES: 'MERGE_IMAGES',
};

export const MAP_API_CREATE_SUBTYPES = {
  [STUDIO_ACTIONS.CREATE_VARIANTS]: STUDIO_API_CREATE_SUBTYPES.VARIANTS,
  [STUDIO_ACTIONS.CREATE_ANGLES]: STUDIO_API_CREATE_SUBTYPES.ANGLES,
  [STUDIO_ACTIONS.ADD_ROOM_FOR_TEXT]: STUDIO_API_CREATE_SUBTYPES.ROOM_FOR_TEXT,
  [STUDIO_ACTIONS.ADD_REALISM]: STUDIO_API_CREATE_SUBTYPES.REALISM,
};

export const MAP_API_ADD_SUBTYPES = {
  [STUDIO_ACTIONS.ADD_LOGO]: STUDIO_API_ADD_SUBTYPES.LOGO,
  [STUDIO_ACTIONS.ADD_TEXT]: STUDIO_API_ADD_SUBTYPES.TEXT,
  [STUDIO_ACTIONS.ADD_VISUAL_ELEMENTS_FROM_TEXT]: STUDIO_API_ADD_SUBTYPES.VISUAL_ELEMENTS_FROM_TEXT,
  [STUDIO_ACTIONS.ADD_VISUAL_ELEMENTS_FROM_IMAGE]: STUDIO_API_ADD_SUBTYPES.VISUAL_ELEMENTS_FROM_IMAGE,
};

export const MAP_API_CHANGE_SUBTYPES = {
  [STUDIO_ACTIONS.CHANGE_SETTING]: STUDIO_API_CHANGE_SUBTYPES.SETTINGS,
  [STUDIO_ACTIONS.CHANGE_STYLE]: STUDIO_API_CHANGE_SUBTYPES.STYLE,
  [STUDIO_ACTIONS.CHANGE_ELEMENT]: STUDIO_API_CHANGE_SUBTYPES.ELEMENT,
};

export const MAP_API_PROMPT_WITH_REFERENCES_SUBTYPES = {
  [STUDIO_ACTIONS.FREE_TEXT_EDIT]: STUDIO_API_PROMPT_WITH_REFERENCES_SUBTYPES.FREE_TEXT,
  [STUDIO_ACTIONS.CHANGE_BRAND_LOOK]: STUDIO_API_PROMPT_WITH_REFERENCES_SUBTYPES.BRAND_LOOK,
  [STUDIO_ACTIONS.MERGE_IMAGES]: STUDIO_API_PROMPT_WITH_REFERENCES_SUBTYPES.MERGE_IMAGES,
};

export const MAP_ACTION_TO_API_OPERATION_TYPE = {
  [STUDIO_ACTIONS.CREATE_FORMATS]: STUDIO_API_OPERATION_TYPES.ASPECT_RATIO,

  [STUDIO_ACTIONS.CREATE_ANGLES]: STUDIO_API_OPERATION_TYPES.CREATE,
  [STUDIO_ACTIONS.CREATE_VARIANTS]: STUDIO_API_OPERATION_TYPES.CREATE,
  [STUDIO_ACTIONS.ADD_ROOM_FOR_TEXT]: STUDIO_API_OPERATION_TYPES.CREATE,
  [STUDIO_ACTIONS.ADD_REALISM]: STUDIO_API_OPERATION_TYPES.CREATE,

  [STUDIO_ACTIONS.CHANGE_SETTING]: STUDIO_API_OPERATION_TYPES.CHANGE,
  [STUDIO_ACTIONS.CHANGE_STYLE]: STUDIO_API_OPERATION_TYPES.CHANGE,
  [STUDIO_ACTIONS.CHANGE_ELEMENT]: STUDIO_API_OPERATION_TYPES.CHANGE,

  [STUDIO_ACTIONS.ADD_LOGO]: STUDIO_API_OPERATION_TYPES.ADD,
  [STUDIO_ACTIONS.ADD_TEXT]: STUDIO_API_OPERATION_TYPES.ADD,
  [STUDIO_ACTIONS.ADD_VISUAL_ELEMENTS_FROM_TEXT]: STUDIO_API_OPERATION_TYPES.ADD,
  [STUDIO_ACTIONS.ADD_VISUAL_ELEMENTS_FROM_IMAGE]: STUDIO_API_OPERATION_TYPES.ADD,

  [STUDIO_ACTIONS.FREE_TEXT_EDIT]: STUDIO_API_OPERATION_TYPES.PROMPT_WITH_REFERENCES,
  [STUDIO_ACTIONS.CHANGE_BRAND_LOOK]: STUDIO_API_OPERATION_TYPES.PROMPT_WITH_REFERENCES,
  [STUDIO_ACTIONS.MERGE_IMAGES]: STUDIO_API_OPERATION_TYPES.PROMPT_WITH_REFERENCES,

  [STUDIO_ACTIONS.CHANGE_CUTOUT_ELEMENT]: STUDIO_API_OPERATION_TYPES.CUTOUT,

  [STUDIO_ACTIONS.CONCEPT_RECREATE]: STUDIO_API_OPERATION_TYPES.RECREATE,

  [STUDIO_ACTIONS.CREATE_VIDEO]: STUDIO_API_OPERATION_TYPES.ANIMATE,
};
